// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-bg-green[data-v-e79a5f96]{background-color:#1ad596}.m-bg-purple[data-v-e79a5f96]{background-color:#c200fb}.m-text-green[data-v-e79a5f96]{color:#1ad596}.m-text-purple[data-v-e79a5f96]{color:#c200fb}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
